<div class="header">
  <!-- Router link here is default ["/"] -->
  <spb-logo></spb-logo>
  <div [style.flex-grow]="1"></div>
  <spb-toggle-button></spb-toggle-button>
</div>